import "@/i18n/config";
import { Focus } from "packs/client_app/components/CommunityMemberDetails/tab/Focus";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import { getTaggers } from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { Absence } from "@/client_app/components/CommunityMemberDetails/tab/Absence";
import { AllComment } from "@/client_app/components/CommunityMemberDetails/tab/AllComment";
import { Coaching } from "@/client_app/components/CommunityMemberDetails/tab/Coaching";
import { Feedback } from "@/client_app/components/CommunityMemberDetails/tab/Feedback";
import { Onboarding } from "@/client_app/components/CommunityMemberDetails/tab/Onboading";
import { Performance } from "@/client_app/components/CommunityMemberDetails/tab/Performance";
interface Props {
  positionId: string;
  inAdmin?: boolean;
}

export interface Tagger {
  id: string;
  full_name: string;
  type: string;
}
const TAB_CLASSES = "focus:outline-none cursor-pointer mr-8 text-base pb-2";
const TAB_ACTIVE_CLASSES =
  "text-legacyColor-neutral-1-900 border-primary-900 font-bold h-full border-b-2";
const TAB_KEYS = [
  "focus",
  "onboarding",
  "coaching",
  "feedback",
  "absence",
  "performance",
  "comment",
];
export function TabSection(props: Props) {
  const { positionId, inAdmin } = props;
  const [taggers, setTaggers] = useState<Tagger[]>([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || TAB_KEYS[0];

  const tabIndex = TAB_KEYS.indexOf(activeTab);

  const handleSelect = (index: number) => {
    searchParams.set("tab", TAB_KEYS[index]);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (positionId) {
      getTaggers(positionId, inAdmin)
        .then((response) => response.json())
        .then((data) => {
          setTaggers(data.taggers);
        });
    }
  }, [positionId]);

  return (
    <Tabs
      selectedIndex={tabIndex}
      onSelect={handleSelect}
      className='text-primary-900'
    >
      <TabList className='flex'>
        <Tab
          key='focus'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Areas of Focus
        </Tab>
        <Tab
          key='onboarding'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Onboarding
        </Tab>
        <Tab
          key='coaching'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Coaching
        </Tab>
        <Tab
          key='feedback'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Feedback
        </Tab>
        <Tab
          key='absence'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Absence
        </Tab>
        <Tab
          key='performance'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          Performance
        </Tab>
        <Tab
          key='comment'
          className={TAB_CLASSES}
          selectedClassName={TAB_ACTIVE_CLASSES}
        >
          All Comments
        </Tab>
      </TabList>
      <TabPanel key='focus'>
        <div className='mt-4'>
          <Focus positionId={positionId} inAdmin={inAdmin} />
        </div>
      </TabPanel>
      <TabPanel key='onboarding'>
        <div className='mt-4'>
          <Onboarding positionId={positionId} inAdmin={inAdmin} />
        </div>
      </TabPanel>
      <TabPanel key='coaching'>
        <div className='mt-4'>
          <Coaching positionId={positionId} inAdmin={inAdmin} />
        </div>
      </TabPanel>
      <TabPanel key='feedback'>
        <div className='mt-4'>
          <Feedback
            positionId={positionId}
            inAdmin={inAdmin}
            taggers={taggers}
          />
        </div>
      </TabPanel>
      <TabPanel key='absence'>
        <div className='mt-4'>
          <Absence
            positionId={positionId}
            inAdmin={inAdmin}
            taggers={taggers}
          />
        </div>
      </TabPanel>
      <TabPanel key='performance'>
        <div className='mt-4'>
          <Performance positionId={positionId} inAdmin={inAdmin} />
        </div>
      </TabPanel>
      <TabPanel key='comment'>
        <div className='mt-4'>
          <AllComment
            positionId={positionId}
            inAdmin={inAdmin}
            taggers={taggers}
          />
        </div>
      </TabPanel>
    </Tabs>
  );
}
